module.exports = __webpack_public_path__ + "static/media/plans.75cdd71b.svg";